export const AUCTION_IMPRESSION_LABELS = [
    "Dealer views on your car ",
    "Similar cars sold (Last Month)"
];

export const TIMER_LABELS = [
    "hrs",
    "mins",
    "secs"
];

export const auctionImpressionLabel = (dealerImpressionEnabled) =>
    dealerImpressionEnabled ? AUCTION_IMPRESSION_LABELS :
        ["Similar cars sold (Last Month)"];
